import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgIconHistory = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsx("path", {
		d: "M12 22.5C17.7989 22.5 22.5 17.799 22.5 12C22.5 6.20101 17.7989 1.5 12 1.5C8.93116 1.5 6.16986 2.8165 4.25 4.91554V3.6C4.25 3.18579 3.91421 2.85 3.5 2.85C3.08579 2.85 2.75 3.18579 2.75 3.6V7.35H6.5C6.91421 7.35 7.25 7.01421 7.25 6.6C7.25 6.18579 6.91421 5.85 6.5 5.85H5.42895C7.07121 4.09604 9.40758 3 12 3C16.9705 3 21 7.02944 21 12C21 16.9706 16.9705 21 12 21C7.57715 21 3.89947 17.8097 3.14262 13.6048C3.07135 13.2089 2.72734 12.9091 2.3256 12.9302C1.8991 12.9527 1.57417 13.3264 1.64473 13.7476C2.4769 18.7148 6.79638 22.5 12 22.5Z",
		fill: "currentColor"
	}), /* @__PURE__ */ _jsx("path", {
		d: "M11.5 6.25C11.9142 6.25 12.25 6.58579 12.25 7V12.07H16C16.4142 12.07 16.75 12.4058 16.75 12.82C16.75 13.2342 16.4142 13.57 16 13.57H11.5C11.0857 13.57 10.75 13.2342 10.75 12.82V7C10.75 6.58579 11.0857 6.25 11.5 6.25Z",
		fill: "currentColor"
	})]
});
export { SvgIconHistory as ReactComponent };
